import { TReduxActions } from '../../../types/redux';
import { FILTERS_SELECT_ALL_OFFER_TYPES_TYPE } from '../../../constants/action_types';
import { defaultState } from './defaultState';
import { EObjectType, IJsonQuery, setTerms } from '../../../utils/jsonQuery';

export function selectAllOfferTypesReducer(jsonQuery: IJsonQuery = defaultState, action: TReduxActions): IJsonQuery {
  switch (action.type) {
    case FILTERS_SELECT_ALL_OFFER_TYPES_TYPE:
      return setTerms('object_type')(jsonQuery)([
        EObjectType.House,
        EObjectType.Housepart,
        EObjectType.Townhouse,
        EObjectType.Land,
      ]);
  }

  return jsonQuery;
}
